module.exports = __webpack_public_path__ + "static/media/3.32316727.png";